import _ from "lodash";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCommunitiesListItems } from "../../../../../redux/community/selector";
import { communities } from "../../../../../redux/community/action";
import { communitySubscriptions } from "../../../../../redux/community-subscriptions/action";
import CommunityDetailsModal from "../components/community-modal.component";
import Popup from "../../../../../common/components/popup";

export const AvailableCommunities = () => {
  const dispatch = useAppDispatch();
  const [dbaasProgram, setDBaasProgram] = useState<any[]>([]);
  const communitiesItems = useSelector(selectCommunitiesListItems);
  const image = require('../../../../../assets/img/image 1.png');
  const [selectCommunity, setSelectCommunity] = useState<any>({});
  const [addItem, setAddItem] = useState<any>(undefined);

  useEffect(() => {
    dispatch(communities.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/excluded-list`,
      entity: 'communities',
      jsonData: {}
    }));
  }, [dispatch]);

  useEffect(() => {
    setDBaasProgram(communitiesItems?.result?.items || []);
  }, [communitiesItems]);

  const fetchCommunities = () => {
    dispatch(communities.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/excluded-list`,
      entity: 'communities',
      jsonData: {}
    }));
  };

  const handleSubscribe = async (data: any) => {
    await dispatch(communitySubscriptions.resetAction({ actionType: 'create' }));
    await dispatch(communitySubscriptions.create({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/subscriptions`,
      entity: 'communitySubscriptions',
      jsonData: {
        Context: {
          Subscription: "ONE",
          Domain: "ONE",
          SubDomains: [],
          Network: "ONEUser",
          Application: "ONEUser",
          Channel: "CSP"
        },
        Records: [
          {
            CommunityId: data.Id,
            IsExistingUser: true,
            OwnerType: "Community"
          }
        ]
      }
    })).then(() => {
      fetchCommunities();
    });
  };

  //model

  const handleDetails = (community: any) => {
    setAddItem({
      id: 0
    });
  
    setSelectCommunity(community)
  }

  const closeModal = () => {
    setAddItem(undefined)
    setSelectCommunity({})
  }


  const NewItemPopup = () => {



    return (
      <>
        <Popup onClose={closeModal}>
          <CommunityDetailsModal
            Close={closeModal}
            selectCommunity={selectCommunity}
          />

        </Popup>
      </>
    )
  }
  //model

  return (
    <>
      {
        addItem ? <NewItemPopup /> : <></>
      }
      <div className="min-h-screen bg-red px-4 py-6">
        <div className="max-w-7xl mx-auto">

          <h2 className="text-center text-xl md:text-2xl font-bold text-gray-800 mb-6">
            Available Communities
          </h2>

          {dbaasProgram.length === 0 ? (
            <div className="text-center text-gray-600 text-md">
              No available communities to show.
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {dbaasProgram.map((community, index) => (
                <div
                  key={community?.Id || index}
                  className="flex flex-col border border-gray-300 rounded-lg bg-gray-50 hover:border-gray-500 hover:shadow-md transition-transform hover:scale-105 p-3"
                >
                  <div className="relative w-full">
                    <div className="w-full h-0 pb-[60%] bg-zinc-200 rounded-md overflow-hidden">
                      <img
                        className="absolute inset-0 w-full h-full object-contain"
                        src={community?.CoverImageUrl || image}
                        alt={community?.Name || "Subscription Image"}
                      />
                    </div>
                  </div>

                  <div className="mt-2 text-sm text-center">
                    <div className="font-semibold text-black truncate">{community?.Name}</div>
                    <div className="text-gray-700 mt-1 text-xs">{community?.Description}</div>
                    <div className="text-gray-500 mt-1 text-xs italic truncate">{community?.seller}</div>
                  </div>

                  <div className="mt-3 flex gap-3">
                    <button
                      className="bg-blue-600 w-40 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-md flex items-center transition duration-200 shadow hover:shadow-lg"
                      onClick={() => handleDetails(community)}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="mr-2">
                        <path d="M12 5v14M5 12h14" />
                      </svg>
                      More Details
                    </button>

                    <button
                      className="bg-green-600 w-40 hover:bg-green-700 text-white text-sm px-4 py-2 rounded-md flex items-center transition duration-200 shadow hover:shadow-lg"
                      onClick={() => handleSubscribe(community)}
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="mr-2">
                        <path d="M12 5v14M5 12h14" />
                      </svg>
                      Subscribe
                    </button>
                  </div>

                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );

};
